"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var moment_addon_1 = __importDefault(require("../../../Addons/moment-addon"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
exports.default = vue_1.default.extend({
    props: ['conceptIds', 'columnLabels', 'cssClass', 'columns'],
    mixins: [ConditionalDisplay_1.default],
    data: function () {
        var model = this.$root.$data;
        var conceptIds = this.columns && this.columns.length > 0 ? this.columns.map(function (_) { return _.conceptId; }) : this.conceptIds;
        var conceptData = model.conceptData.filter(function (d) { return conceptIds.indexOf(d.conceptId) != -1; });
        var byIdentifier = $.groupBy(conceptData, "inputIdentifier");
        var identifiers = Object.keys(byIdentifier);
        var data = [];
        for (var _i = 0, identifiers_1 = identifiers; _i < identifiers_1.length; _i++) {
            var id = identifiers_1[_i];
            var conceptValues = byIdentifier[id];
            var date = conceptValues[0].date;
            data.push({
                date: moment_addon_1.default(date),
                entries: conceptIds.map(function (cid) { return conceptValues.find(function (v) { return v.conceptId == cid; }); })
            });
        }
        data.sort(function (a, b) { return a.date - b.date; });
        return {
            tableData: data
        };
    },
    methods: {
        getEntryValue: function (entry, idx) {
            var col = this.columns[idx], val = entry.valueFormatted;
            return val + " " + (val && val !== "" && col.suffix ? col.suffix : "");
        }
    },
    computed: {
        hasSum: function () {
            return this.columns && this.columns.find(function (_) { return _.toSum; }) != null;
        },
        labels: function () {
            return this.columns ? this.columns.map(function (_) { return _.label; }) : this.columnLabels;
        },
        totalValue: function () {
            var _this = this;
            var total = 0, isDecimal = false, suffix = null;
            this.tableData.map(function (row) {
                row.entries.map(function (e, i) {
                    if (e) {
                        var val = void 0, col = _this.columns[i];
                        if (col.toSum
                            && (val = e.valueNumeric)
                            && val != "") {
                            if (!isDecimal && e.type && e.type === "Decimal") {
                                isDecimal = true;
                            }
                            if (!suffix) {
                                suffix = col.suffix || "";
                            }
                            total += val;
                        }
                    }
                });
            });
            return (isDecimal ? total.toFixed(2).replace(".", ",") : total) + " " + suffix;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Output/OzConceptTable.vue
// module id = 219
// module chunks = 0